import {createContext} from 'react';

import {DocumentStoreApi} from '@/components/document/store/document-store';
import {DocumentModel, DocumentSection, DocumentValue, ValueResolver, VisibilitySet} from '@/engine';
import {DocumentForm, FullDocument} from '@/interfaces/document';
import {FieldError} from '@/types/document/store';

export type DocumentContextType = {
  ready: boolean;
  visibleSections: DocumentSection[];
  currentSectionId: string;
  currentSectionIndex: number;
  currentSection: DocumentSection | null;
  nextSection: DocumentSection | null;
  sectionRemountKey: string;
  document: FullDocument;
  documentModel: DocumentModel;
  hasUnsavedChanges: boolean;
  forms: DocumentForm[];
  setForms: (forms: DocumentForm[]) => void;
  isSaving: boolean;
  hasSavingError: boolean;
  isSubmitting: boolean;
  resetCompleteForm: () => void;
  resetCurrentSection: () => void;
  resubmitForSignature: () => Promise<void>;
  saveChanges: () => Promise<void>;
  serialize: (value: DocumentValue | DocumentValue[]) => string;
  setCurrentSectionId: (sectionId: string) => void;
  setSectionValidity: (sectionId: string, isValid: boolean, errors?: FieldError[]) => void;
  store: DocumentStoreApi;
  submitForSignature: () => Promise<void>;
  submitSection: () => Promise<void>;
  valueResolver: ValueResolver;
  visibilitySet: VisibilitySet;
};

export const DocumentContext = createContext<DocumentContextType | null>(null);
